<template>
  <div class="mt-8">
    <px-view-module-header module-name="Cotações" :breadcrumbs="breadcrumbs"/>
    <v-alert type="primary" class="rounded-card" outlined dismissible>
      <b>Esse é um feedback automático gerado pela Proxpect</b>
    </v-alert>
    <px-view-header-title class="mt-8" title="Feedback">
      <template v-slot:before>
        <v-btn class="mb-1 mr-1" icon x-large color="primary" link to="/cotacoes">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header-title>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="produtos">
      <v-card class="rounded-card card-shadow">
        <v-card-title>Feedback por produto</v-card-title>
        <v-simple-table>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">Produto</th>
              <th class="text-center">Preço</th>
              <th class="text-center">Prazo de pagamento</th>
              <th class="text-center">Prazo de embarque</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in produtos" :key="index">
              <td>{{ item.produto.descricao }}</td>
              <td>
                <v-row class="justify-center">
                  <px-status-feedback :status="item.preco"/>
                </v-row>
              </td>
              <td>
                <v-row class="justify-center">
                  <px-status-feedback :status="item.prazoPagamento"/>
                </v-row>
              </td>
              <td>
                <v-row class="justify-center">
                  <px-status-feedback :status="item.prazoEmbarque"/>
                </v-row>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
      <px-feedback-legenda class="mt-3"/>
    </div>
  </div>
</template>

<script>
import FeedbackLegenda from './FeedbackLegenda.vue';
import FeedbackService from './feedback-service';

export default {
  data() {
    return {
      solicitacaoId: this.$route.params.id,
      loading: false,
      produtos: null,
      breadcrumbs: [
        { text: 'Negócios' },
        {
          text: 'Cotações',
          to: '/cotacoes',
        },
        { text: 'Feedback' },
      ],
    };
  },
  methods: {
    close() {
      this.dialog = false;
    },
    getFeedback() {
      this.loading = true;
      FeedbackService.getFeedback(this.solicitacaoId)
        .then((response) => {
          this.produtos = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getFeedback();
  },
  components: {
    pxFeedbackLegenda: FeedbackLegenda,
  },
};
</script>
